import { render } from "./gallery-section.vue?vue&type=template&id=7204982d"
import script from "./gallery-section.vue?vue&type=script&lang=js"
export * from "./gallery-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__